// src/api/authEvents.js
let onAuthFail = null;

/**
 * Register a callback that will be triggered when auth refresh fails.
 * Call this once from AuthProvider.
 */
export const setOnAuthFail = (fn) => {
  onAuthFail = fn;
};

/**
 * Trigger auth failure (e.g., refresh token expired/invalid).
 * This will immediately update UI + disconnect sockets.
 */
export const triggerAuthFail = () => {
  if (typeof onAuthFail === "function") onAuthFail();
};